import type { ReactNode } from 'react'

type Props = {
  title: string
  subtitle: string
  contents: ReactNode
}

export const AnalyticsCard = ({ title, subtitle, contents }: Props) => {
  return (
    <div className="relative min-w-[340] rounded-md bg-surface-backgroundElevated py-[18px] px-6 flex flex-col gap-2">
      <div className="flex flex-col gap-1">
        <h2 className="font-EN-KR-sub-heading-bold text-contents-primary">{title}</h2>
        <p className="font-EN-KR-caption-regular text-contents-tertiary">{subtitle}</p>
      </div>
      {contents}
    </div>
  )
}
